import React from "react";

function About() {
  return (
    <>
      <section className="about" id="about">
        <div className="container" style={{ width: 1116, marginTop: 70 }}>
          <div className="row">
            <div className=" text-center about_us">
              <h1 style={{ marginTop: 70 }}>
                <b>About Us</b>
              </h1>

              {/* <div className="border"></div> */}
            </div>

            {/* <div className="col-md-6">
              <img src="images/about.png" className="img-fluid" alt="" />
            </div> */}
            <div className="col-md-8">
              <div>
                <br></br> <i className="tf-ion-android-checkmark-circle"></i>{" "}
                <b>Mission:</b> to deliver innovative, solution-driven & best
                experience business solution.
              </div>
              <div>
                <br></br> <i className="tf-ion-android-checkmark-circle"></i>{" "}
                <b>Vision: </b> to accelerate your business transition from
                legecy systems to a digital environment.
              </div>
              <div>
                <br></br> <i className="tf-ion-android-checkmark-circle"></i>{" "}
                <b>Goal: </b>to ensure service transparecy & sustainability.
              </div>
              <div>
                <br></br> <i className="tf-ion-android-checkmark-circle"></i>{" "}
                <b>Year of founding: </b>
                2019
              </div>

              <div>
                <br></br> <i className="tf-ion-android-checkmark-circle"></i>{" "}
                <b>HQ: </b>
                Pune
              </div>
              <br></br>
              <h5 className="text-left">
                <b>Industries served:</b>
              </h5>
              <ul className="feature-list">
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i>{" "}
                  Manufacturing
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> Chemical
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i>{" "}
                  Construction
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> Market
                  Research
                </li>
                <li>
                  {" "}
                  <i className="tf-ion-android-checkmark-circle"></i> Software
                  Service
                </li>
              </ul>
              {/* <a href="/" className="btn btn-main mt-20">
                Learn More
              </a> */}
            </div>
          </div>
        </div>
      </section>

      <section className="call-to-action-2 section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2>Milestones and Service Overviews</h2>
            </div>
            <div className="col-md-6">
              <p>
                {" "}
                <i className="tf-ion-android-checkmark-circle"></i> Successful
                integration of SAP and Whats app application for 4 leading
                service brands.
              </p>
              <p>
                {" "}
                <i className="tf-ion-android-checkmark-circle"></i> Successful
                integration of SAP and Tally system for over 32 customers,
                including many leading brands.
              </p>

              <p>
                {" "}
                <i className="tf-ion-android-checkmark-circle"></i> Developed
                and implemented CRM for construction in 2021.
              </p>
            </div>
            <div className="col-md-6">
              <p>
                {" "}
                <i className="tf-ion-android-checkmark-circle"></i> Integrated 2
                CRM for 2 leading real estate brands
              </p>

              <p>
                {" "}
                <i className="tf-ion-android-checkmark-circle"></i> Integrated
                GATI transporter system with SAP to track invoice.
              </p>
              <p>
                {" "}
                <i className="tf-ion-android-checkmark-circle"></i> Developed
                and implemented web-based tailor made ERP for customers.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
